<delivery-activity-chart
  [rows]="rows()"
  [loading]="loading()"
  [shiftConfig]="shiftConfig()"
  [timeScale]="timeScale()"
  [startDate]="startDate()"
  [endDate]="endDate()"
  (rowClick)="navigateToBlast($event)"
  (deliveryClick)="navigateToDelivery($event)"
  (dateRangeChange)="onDateRangeChange($event)"
  (selectedShiftsChange)="onSelectedShiftsChange($event)"
/>

<div class="report-actions">
  <button
    class="btn btn-outline-success"
    type="button"
    [disabled]="isReportActionDisabled()"
    (click)="openReportModal()"
  >
    Generate delivery report
  </button>

  <span class="report-selection-summary">
    {{ selectedShifts().length }} shifts selected • {{ selectedDeliveryIds().length }} deliveries
  </span>
</div>
